import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Snackbar, Alert, Button } from '@mui/material';
import { selectToastError } from '../../store/duckers/error/selectors';
import { clearError } from '../../store/duckers/error/slice';
import { runActionHandler, hasUsableAction } from '../../utils/errorActionHandler';
import { sendOtpRequest } from '../../store/duckers/otp/thunk';
import type { AppDispatch } from '../../store';
import { UserType } from '../../constants/types';

const KLErrorToaster: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const params = useParams<{ businessId?: string }>();
  const error = useSelector(selectToastError);

  if (!error) return null;

  const handleClose = () => dispatch(clearError());

  const handleAction = () => {
    runActionHandler(error.action, {
      dispatch,
      navigate,
      businessId: params.businessId,
      lastPhone: undefined,
      resendOtp: (phone) =>
        dispatch(sendOtpRequest({ phoneNumber: phone, userType: UserType.Customer })),
    });
  };

  const hasActionButton = hasUsableAction(error.action);

  return (
    <Snackbar
      open
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={6000}
    >
      <Alert
        severity="error"
        role="alert"
        onClose={hasActionButton ? handleClose : undefined}
        action={
          hasActionButton ? (
            <Button color="inherit" size="small" onClick={handleAction}>
              {error.action.label}
            </Button>
          ) : undefined
        }
      >
        {error.message}
      </Alert>
    </Snackbar>
  );
};

export default KLErrorToaster;
